var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedSales ? '编辑' : '新增'}销售项目`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Modal', {
    attrs: {
      "title": "删除销售项目"
    },
    on: {
      "on-ok": _vm.delSales
    },
    model: {
      value: _vm.delSalesModal,
      callback: function ($$v) {
        _vm.delSalesModal = $$v;
      },
      expression: "delSalesModal"
    }
  }, [_c('p', [_vm._v("你确定要删除此销售项目吗？")])]), _c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.openedSales ? true : false,
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.customerLoading,
      "placeholder": "请填写客户名字后选择"
    },
    model: {
      value: _vm.formItem.customer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "customer", $$v);
      },
      expression: "formItem.customer"
    }
  }, _vm._l(_vm.customersSimple, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "366px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "产品",
      "prop": "material"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.material,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "material", $$v);
      },
      expression: "formItem.material"
    }
  }, _vm._l(_vm.materialList, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "366px",
        "overflow": "hidden",
        "white-space": "pre-wrap"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.model) + " " + _vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "代称",
      "prop": "abbr"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "比如惠州建华管桩有限公司的STH-20产品，代称为“建华"
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "金蝶云物料代码",
      "prop": "JDItemCode"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "金蝶云物料代码"
    },
    model: {
      value: _vm.formItem.JDItemCode,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "JDItemCode", $$v);
      },
      expression: "formItem.JDItemCode"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "合同签署公司",
      "prop": "company"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "利润归属公司",
      "prop": "profitBelongCompany"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-clear": _vm.clearProfitBelongCompany
    },
    model: {
      value: _vm.formItem.profitBelongCompany,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "profitBelongCompany", $$v);
      },
      expression: "formItem.profitBelongCompany"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "发货工厂",
      "prop": "factory"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.factory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "factory", $$v);
      },
      expression: "formItem.factory"
    }
  }, _vm._l(_vm.factoryList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "公司内部项目",
      "prop": "internalShipping"
    }
  }, [_c('i-switch', {
    on: {
      "on-change": _vm.changeInternalShipping
    },
    model: {
      value: _vm.isInternalShipping,
      callback: function ($$v) {
        _vm.isInternalShipping = $$v;
      },
      expression: "isInternalShipping"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")]), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function ($event) {
        _vm.drawerOpened = false;
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }